module.exports = __webpack_public_path__ + "img/background.8a1c20ab.png";